
import React, { Component } from "react";
import "./custom-graph.component.css"
export default class CustomLegend extends Component {
    render() {
        const { payload, ledger } = this.props;
        return (
            <div className="custom-legend-container" >
                {payload.map((entry, index) => {
                    const correspondingLedgerItem = ledger.find(item => item.name === entry.dataKey);
                    return (
                        <div key={`item-${index}`} className="custom-legend-sub-component">   
                            <div className={`custom-indicator-${correspondingLedgerItem.color}`}>

                            </div>                        
                            <span>
                                {correspondingLedgerItem.label}
                            </span>
                        </div>
                    );
                })}
            </div>
        );
    }
}